// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/select/index.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Primary} from './Primary.story';
import {Disabled} from './Disabled.story';
import {Uncontrolled} from './Uncontrolled.story';

const basic = {
  rendered: <Primary />,
  source: `<Select
  name="demo-001"
  label="Choose a pet"
  onChange={(e) => {
    console.log(e);
  }}
>
  <option value="">Choose an option</option>
  <option value="dogs">Dogs</option>
  <option value="cats">Cats</option>
</Select>`,
};
const disabled = {
  rendered: <Disabled />,
  source: `<Select name="demo-001" disabled label="Choose a pet">
  <option value="">Choose an option</option>
  <option value="dogs">Dogs</option>
  <option value="cats">Cats</option>
</Select>`,
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<Select
  name="demo-001"
  onChange={(e) => {
    console.log(e);
  }}
  label="Choose a pet"
>
  <option value="">Choose an option</option>
  <option value="dogs">Dogs</option>
  <option value="cats">Cats</option>
</Select>`,
};
export const SelectExamples = {
  basic,
  uncontrolled,
  disabled,
};
